module.exports = __webpack_public_path__ + "img/allow-down-grey.58929459.svg";